const InsuranceChallenge1HintsText =
    ["There are 2 items that should end up in the 'not covered by your insurance.",
     "If there is damage to your car, it is not covered by Home Insurance even " +
        "if your car is parked in your driveway",
     "If you lend your car to a friend, the claim is filed against your insurance " +
        "even if your friend has automobile insurance.",
     "If expensive items are stolen from your car, it is not covered by auto " +
        "insurance."
    ]

export default InsuranceChallenge1HintsText;